import React from 'react';

export const FileIcon = () => (
  <svg role="none" width="10" height="12" viewBox="0 0 10 12">
    <path d="M9.08317 11.8331V3.66644H6.74984C6.10642 3.66644 5.58317 3.14319 5.58317 2.49978V0.166443H0.916504V10.6664C0.916504 11.3104 1.43917 11.8331 2.08317 11.8331H9.08317ZM9.08317 3.08311H6.74984C6.42842 3.08311 6.1665 2.82178 6.1665 2.49978V0.166443L9.08317 3.08311Z" />
  </svg>
);
